module.exports = __webpack_public_path__ + "img/apple.7a1ec0b5.webp";